<script>
	// NPM Modules
	import { tick } from 'svelte';
	import collect from 'collect.js';
	import Link from 'svelte-navaid/Link.svelte';
	// Stores
	import CompetitionStore from '@/Stores/Sport/CompetitionStore';
	import SportStore from '@/Stores/Sport/SportStore';
	// Partials
	import UpdateCompetition from '@/Partials/Sport/Manage/Competitions/_Update.svelte';
	import CreateCompetition from '@/Partials/Sport/Manage/Competitions/_Create.svelte';
	import RemapSportcast from '@/Partials/Sport/Manage/Competitions/_RemapSportcast.svelte';
	import ListCompetitions from '@/Partials/Sport/Manage/Competitions/_List.svelte';
	import FeaturedCompetitions from '@/Partials/Sport/Manage/Competitions/_Featured.svelte';
	import CompetitionTiers from '@/Partials/Sport/Manage/Competitions/_Tiers.svelte';
	// Components
	import Switch from '@/Components/Switch.svelte';

	export let sport;
	export let tab;

	let showCreateCompetition = false;
	let showUpdateCompetition = false;
	let showRemapSportcast = false;
	let selectedCompetition;
	let onlyShowManual = false;

	let competitions;

	$: sport && $SportStore && getCompetitions();
	$: filteredCompetitions = competitions && (onlyShowManual || !onlyShowManual) && filterCompetitions(competitions);

	function getCompetitions() {
		CompetitionStore.getCompetitionsForSport(sport.id, null, true, true).then(() => {
			competitions = $CompetitionStore.sortBy('name') ?? false;
		});
	}

	async function openCreateCompetition() {
		showCreateCompetition = true;
		await tick();
		window.scrollTo(0, 0);
	}

	async function openUpdateCompetition() {
		showUpdateCompetition = true;
		await tick();
		window.scrollTo(0, 0);
	}

	async function openRemapSportcast() {
		showRemapSportcast = true;
		await tick();
		window.scrollTo(0, 0);
	}

	function filterCompetitions(competitionsToBeFiltered) {
		let competitionsToFilter = competitionsToBeFiltered ?? collect();

		if (onlyShowManual) {
			competitionsToFilter = competitionsToFilter.where('is_manual', true);
		}

		return competitionsToFilter.all();
	}
</script>

{#if showCreateCompetition}
	<CreateCompetition bind:open={showCreateCompetition} bind:sport on:created={() => getCompetitions()} />
{:else if showUpdateCompetition}
	<UpdateCompetition
		bind:open={showUpdateCompetition}
		bind:competition={selectedCompetition}
		on:updated={() => getCompetitions()}
	/>
{:else if showRemapSportcast}
	<RemapSportcast
		bind:open={showRemapSportcast}
		bind:competition={selectedCompetition}
		on:updated={() => getCompetitions()}
	/>
{/if}

<div>
	<div class="flex items-center justify-center w-full">
		<div class="btn-group">
			<Link
				href={`/sport/manage/${sport.id}/competitions`}
				class="btn {tab === undefined || tab === null ? 'btn-primary-action' : 'btn-muted text-dark'}"
			>
				Competitions
			</Link>
			<Link
				href={`/sport/manage/${sport.id}/competitions/featured`}
				class="btn {tab === 'featured' ? 'btn-primary-action' : 'btn-muted text-dark'}"
			>
				Featured Competitions
			</Link>
			<Link
				href={`/sport/manage/${sport.id}/competitions/tiers`}
				class="btn {tab === 'tiers' ? 'btn-primary-action' : 'btn-muted text-dark'}"
			>
				Competition Tiers
			</Link>
		</div>
	</div>
	<div class="flex items-center justify-between w-full">
		{#if tab === undefined || tab === null}
			<div class="flex flex-row">
				<Switch bind:checked={onlyShowManual} className="-mt-1 ml-6" />
				<div class="ml-3">Show manual competitions only</div>
			</div>
			<button on:click={() => openCreateCompetition()} class="btn btn-primary"> Create manual competition </button>
		{/if}
	</div>
	{#if competitions}
		{#if tab === 'featured'}
			<FeaturedCompetitions {sport} {competitions} />
		{:else if tab === 'tiers'}
			<CompetitionTiers {sport} {competitions} />
		{:else}
			<ListCompetitions
				bind:competitions={filteredCompetitions}
				bind:sport
				bind:selectedCompetition
				on:selected={() => openUpdateCompetition()}
				on:sportcast={() => openRemapSportcast()}
			/>
		{/if}
	{/if}
</div>
